import accordionGroupUlTemplate from './accordion-group-ul.html';

const accordionGroupUlRun = /* @ngInject */ (/** @type {import('angular').ITemplateCacheService} */ $templateCache) => {
	$templateCache.put('accordion-group-ul.html', accordionGroupUlTemplate);
};

export default accordionGroupUlRun;
